// extracted by mini-css-extract-plugin
export var content = "PageSection-module--content--6ff93";
export var dark = "PageSection-module--dark--865dd";
export var padY = "PageSection-module--pad-y--19878";
export var section = "PageSection-module--section--15dd6";
export var seeThrough = "PageSection-module--see-through--bbffc";
export var thin = "PageSection-module--thin--75707";